import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";

const EditStateComponent = loadable(
  () => import("../../components/State/EditState")
);
const EditState = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: [`state-${id}`],
    url: `${APIS.LOCATION}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`state-${id}`],
    navigateURL: "/state",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit State</span>
      </div>
      <EditStateComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
      />
    </>
  );
};
export default EditState;
